import { useEffect, useState } from "react";
import { Ticket } from "lucide-react";
import { Monogram } from "./ornaments";
import { scrollToId } from "../lib/scroll";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "glass-gold py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 sm:px-8">
        <button
          data-testid="nav-home-link"
          onClick={() => scrollToId("hero")}
          className="flex items-center gap-3 text-left"
        >
          <Monogram size={38} />
          <span className="hidden sm:block">
            <span className="font-script text-2xl text-gold-light leading-none">Stephanie</span>
            <span className="block text-[10px] uppercase tracking-[0.3em] text-mist mt-1">Dec 5 · Sarasota</span>
          </span>
        </button>

        <nav className="flex items-center gap-6 sm:gap-8">
          <button data-testid="nav-events-link" onClick={() => scrollToId("events")} className="hidden md:block text-xs uppercase tracking-[0.25em] text-ivory/80 hover:text-gold-light transition-colors duration-300">
            The Celebrations
          </button>
          <button data-testid="nav-livestream-link" onClick={() => scrollToId("livestream")} className="hidden md:block text-xs uppercase tracking-[0.25em] text-ivory/80 hover:text-gold-light transition-colors duration-300">
            Livestream
          </button>
          <button
            data-testid="nav-rsvp-cta"
            onClick={() => scrollToId("rsvp")}
            className="group flex items-center gap-2 rounded-full bg-gradient-to-r from-gold-pale via-gold to-gold-deep px-5 py-2.5 text-xs font-semibold uppercase tracking-[0.2em] text-navy-deep transition-transform duration-300 hover:scale-[1.04] active:scale-95"
          >
            <Ticket size={14} className="transition-transform duration-300 group-hover:-rotate-12" />
            RSVP
          </button>
        </nav>
      </div>
    </header>
  );
};
